import React from "react";
import { designer } from "../data/portfolio";

export const Footer = () => {
  return (
    <footer
      className="relative border-t border-[#E4E6EC]/70 py-10 px-6 md:px-10 bg-[#FFFFFF]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row gap-6 md:items-end justify-between">
        <div>
          <div className="font-display text-3xl tracking-tight text-[#0E1A2B]">
            {designer.name}
          </div>
          <div className="mt-1 text-xs tracking-[0.22em] uppercase text-[#6E7583]">
            {designer.role} · {designer.location}
          </div>
        </div>
        <div className="text-xs tracking-[0.22em] uppercase text-[#6E7583]">
          © {new Date().getFullYear()} — Made slowly, on purpose.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
